import { RequestUtil, GTMUtil } from '@vibrent/electryon';

import MessageBox from './messageBox';
import { Constants } from './constants';
import CustomPropTypes from './customPropTypes';
import DateUtil from './dateUtil';
import Models from './models';
import ToolTipTextOverflow from './toolTipTextOverflow';
import ColoredCheckBox from './coloredCheckbox';
import * as FieldForm from './fieldForm';
import UrlUtil from './urlUtil';

const request = new RequestUtil();

const gtmPushTagManager = (eventName, params) =>
  (dispatch, getState) => {
    const userDetailReducer = getState().UserDetail;
    const userDetails = (userDetailReducer && userDetailReducer.get('userDetail')) || {};
    const currentActiveProgram = (userDetailReducer &&
      userDetailReducer.get('currentActiveProgram')) || {};
    const userData = {
      userDetail: {
        ...userDetails,
        ...currentActiveProgram,
      },
      roleSelected: (userDetailReducer && userDetailReducer.get('roleSelected')) || null,
      nodeData: (userDetailReducer && userDetailReducer.get('nodeData')) || [],
    };
    GTMUtil.pushTagManager(userData, eventName, params);
  };

export {
  MessageBox,
  Models,
  Constants,
  CustomPropTypes,
  DateUtil,
  ToolTipTextOverflow,
  request as RequestUtil,
  ColoredCheckBox,
  UrlUtil,
  gtmPushTagManager,
};

export { FieldForm };
export { default as Field } from './fieldForm';
export * from './fieldForm/validator';
